var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "54px",
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/DKT/Player/Play-Circle-Black",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SO-Iconset-SVGs_Black---Play-Kreis",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 25,
    cy: 25,
    r: 25
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Save_2209758",
    transform: "translate(11.000000, 11.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,20.3402367 L28,26.5798817 C28,26.704142 27.9823678,26.8195266 27.9559194,26.9260355 L27.9559194,26.9260355 C27.9559194,26.9260355 27.9559194,26.9260355 27.9559194,26.9260355 C27.8324937,27.5384615 27.2947103,28 26.6599496,28 L1.33123426,28 C0.652392947,28 0.0881612091,27.4763314 0.0176322418,26.8106509 C0,26.7307692 0,26.6597633 0,26.5710059 L0,20.3313609 C0,19.5946746 0.599496222,19 1.32241814,19 C1.68387909,19 2.01889169,19.1508876 2.25692695,19.3905325 C2.49496222,19.6301775 2.64483627,19.9674556 2.64483627,20.3313609 L2.64483627,25.3284024 L25.3639798,25.3284024 L25.3639798,20.3313609 C25.3639798,19.5946746 25.9634761,19 26.686398,19 C27.0478589,19 27.3828715,19.1508876 27.6209068,19.3905325 C27.8501259,19.6390533 28,19.9763314 28,20.3402367 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arrow",
    d: "M21.551103,14.0555324 L15.1122475,20.5177453 C15.1035109,20.5352818 15.0860377,20.5440501 15.0773012,20.5528184 C14.8414136,20.7895616 14.5356335,20.9386221 14.2298534,20.9824635 C14.2036437,20.9824635 14.177434,20.9912317 14.1512242,20.9912317 C14.0988048,21 14.0463853,21 13.9939659,21 L13.8454441,20.9912317 C13.8192344,20.9912317 13.7930247,20.9824635 13.7668149,20.9824635 C13.4522983,20.9386221 13.1552547,20.7895616 12.9193672,20.5528184 C12.9106306,20.5440501 12.8931575,20.5265136 12.8844209,20.5177453 L6.44556531,14.0555324 C6.14852177,13.7574113 6,13.3628392 6,12.9682672 C6,12.5736952 6.14852177,12.1791232 6.44556531,11.8810021 C7.03965239,11.2847599 8.00941219,11.2847599 8.61223585,11.8810021 L12.4825385,15.7653445 L12.4825385,1.53444676 C12.4825385,0.692693111 13.1727279,0 14.011439,0 C14.4307946,0 14.8152039,0.175365344 15.0947743,0.447181628 C15.3743447,0.72776618 15.5403396,1.10480167 15.5403396,1.53444676 L15.5403396,15.7653445 L19.4106422,11.8810021 C20.0047293,11.2847599 20.9744891,11.2847599 21.5773128,11.8810021 C22.1451901,12.4860125 22.1451901,13.4592902 21.551103,14.0555324 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/Download Icon.e4fd5fede52c36a994927cae31440294.svg";
export { ForwardRef as ReactComponent };